import ReactPiwik from "react-piwik";

export function initMatomo() {
  const piwik = new ReactPiwik({
    url: 'tracking.jde-mediabox.com',
    siteId: 1,
    trackErrors: true,
    trackPageView: true,
    enableLinkTracking: true,
    jsFilename: 'blockadblock.js',
    phpFilename: 'blockadblock.php'
  });
  ReactPiwik.push(['addDownloadExtensions', "jpg|jpeg|eps|zip|png"]);
  return piwik;
}